export default class Administrador {
  constructor(id, nombreCompleto, correo, contrasena, salt) {
    this.id = id;
    this.nombreCompleto = nombreCompleto;
    this.correo = correo;
    this.contrasena = contrasena;
    this.salt = salt;
  }
}
